// store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const InvestorSlice = createSlice({
  name: "investor",
  initialState: {
    investorId: localStorage.getItem("investorId") || null,
    investorName: localStorage.getItem("investorName") || "",
    cashReserve: localStorage.getItem("cashReserve") || 0,
  },
  reducers: {
    setInvestorId: (state, action) => {
      localStorage.setItem("investorId", action.payload);
      state.investorId = action.payload;
    },
    setInvestorName: (state, action) => {
      localStorage.setItem("investorName", action.payload);
      state.investorName = action.payload;
    },
    setCashReserve: (state, action) => {
      localStorage.setItem("cashReserve", action.payload);
      state.cashReserve = action.payload;
    },
    clearCashReserve: (state) => {
      localStorage.removeItem("cashReserve");
      state.cashReserve = null;
    },
    clearInvestorId: (state) => {
      localStorage.removeItem("investorId");
      state.investorId = null;
    },
    clearInvestorName: (state) => {
      localStorage.removeItem("investorName");
      state.investorName = null;
    },
  },
});

export const {
  setInvestorId,
  clearInvestorId,
  setInvestorName,
  clearInvestorName,
  clearCashReserve,
  setCashReserve
} = InvestorSlice.actions;
export default InvestorSlice.reducer;
